/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NetworkSchema
 */
export interface NetworkSchema {
    /**
     * 
     * @type {string}
     * @memberof NetworkSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NetworkSchema
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NetworkSchema
     */
    link: string;
}

/**
 * Check if a given object implements the NetworkSchema interface.
 */
export function instanceOfNetworkSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "link" in value;

    return isInstance;
}

export function NetworkSchemaFromJSON(json: any): NetworkSchema {
    return NetworkSchemaFromJSONTyped(json, false);
}

export function NetworkSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): NetworkSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
        'link': json['link'],
    };
}

export function NetworkSchemaToJSON(value?: NetworkSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
        'link': value.link,
    };
}

